import axios from '@axios';

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        sendEmailWithReportAttached(ctx, { id, payload }) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/forms/${id}/send-email-with-report-attached`, payload)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        sendEmailWithVerificationResponse(ctx, { id, payload }) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/verify/${id}/send-email-with-verification-response`, payload)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        }
    }
}